import z from "zod";

export const CART_COOKIE_NAME = "cart";

export const cartCookieSchema = z.object({
  productIds: z.array(z.string()),
});

export type CartCookie = z.infer<typeof cartCookieSchema>;
